<!-- prettier-ignore -->
<div class="breadcrumb-bar">
  <app-breadcrumb
    [titles]="[{ label: 'レビュー一覧', url: '/hospital/reviews' },{ label: 'データ種一覧（' + reviewId + '）' }]"
  />

  @if (targetHospitalName) {
    <span class="hospital-badge" aria-label="対象施設名">
      {{ targetHospitalName }}
    </span>
  }
</div>

<!-- prettier-ignore -->
<div>
@if (reviewState$ | async; as state) {
  @switch (state.status) {

    @case ('loading') {
      <app-skeleton type="table" />
      <app-spinner message="読み込み中" />
    }

    @case ('success') {
      @if (targets$ | async; as targets) {
        @if (targets.length > 0) {
          <div class="data-type-container">
            <div class="bulk-download-wrapper">
              <button
                class="bulk-download-button"
                (click)="onDownload(bulkDownloadAddress)"
                aria-label="データを一括ダウンロード"
              >
                <app-icon
                  name="filedownload"
                  height="1.75rem"
                  width="1.75rem"
                  color="var(--color-link)"
                />
                <span class="bulk-download-text">一括ダウンロード</span>
              </button>
            </div>

            <div class="table-container" #tableContainer>
              <table class="responsive-table">
                <caption class="table-description">データ種一覧</caption>
                <thead>
                  <tr>
                    <th class="no-col" scope="col">No</th>
                    <th class="text-left" scope="col">データ種</th>
                    <th class="text-left" scope="col">テーブル名</th>
                    <th class="text-right" scope="col">カラム数</th>
                    <th class="text-right" scope="col">レコード数</th>
                    <th class="text-center download-col" scope="col">ダウンロード</th>
                  </tr>
                </thead>

                <tbody>
                  @for (target of targets; track target.dataType; let i = $index) {
                    <tr>
                      <td class="no-col">{{ i + 1 }}</td>
                      <td class="text-left">
                        <a [routerLink]="['/hospital', 'reviews', reviewId, 'data-types', target.dataType, 'anonymized-data']"
                           (click)="saveScrollPosition()"
                        >
                          {{ target.dataName }}
                        </a>
                      </td>
                      <td class="text-left">{{ target.dataType }}</td>
                      <td class="text-right">{{ target.recordColumn | number }}</td>
                      <td class="text-right">{{ target.recordNumber | number }}</td>

                      <td class="download-col">
                        <button
                          class="download-button"
                          (click)="onDownload(target.csvAddress)"
                          aria-label="データをダウンロード"
                        >
                          <app-icon
                            name="filedownload"
                            height="1.75rem"
                            width="1.75rem"
                            color="var(--color-link)"
                          />
                        </button>
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>
        } @else {
          <app-skeleton type="table" [messages]="['データ種一覧が登録されていません']"/>
        }
      }
    }

    @case ('error') {
      <app-skeleton
        type="alert"
        [messages]="['データ種一覧データの取得に失敗しました。','しばらくしてから再度お試しください。']"
      />
    }

  }
}
</div>
